import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Base URL (adjust as needed)
const API_URL = 'https://api.aweioio.com/api/menu';

// Thunks
export const fetchMenu = createAsyncThunk("menu/fetchMenu", async () => {
    const response = await axios.get(API_URL); // Update the API URL if needed
    return response.data;
});

export const fetchFeaturedMenu = createAsyncThunk("menu/fetchFeaturedMenu", async () => {
    const response = await axios.get(`${API_URL}/featured`);
    return response.data;
});

export const createMenuItem = createAsyncThunk(
    "menu/createMenuItem",
    async (item) => {
        console.log(item, "iem slice")
        const response = await axios.post("https://api.aweioio.com/api/menu", item);
        return response.data;
    }
);

export const updateMenuItem = createAsyncThunk("menu/updateMenuItem", async ({ id, item }) => {
    const response = await axios.put(`${API_URL}/${id}`, item);
    return response.data;
});

export const deleteMenuItem = createAsyncThunk("menu/deleteMenuItem", async (id) => {
    await axios.delete(`${API_URL}/${id}`);
    return id;
});

// Slice
const menuSlice = createSlice({
    name: "menu",
    initialState: {
        items: [],
        featured: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Fetch All
            .addCase(fetchMenu.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchMenu.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(fetchMenu.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            // Fetch Featured
            .addCase(fetchFeaturedMenu.fulfilled, (state, action) => {
                state.featured = action.payload;
            })
            // Create
            .addCase(createMenuItem.fulfilled, (state, action) => {
                state.items.push(action.payload);
            })
            // Update
            .addCase(updateMenuItem.fulfilled, (state, action) => {
                const index = state.items.findIndex((item) => item._id === action.payload._id);
                if (index !== -1) state.items[index] = action.payload;
            })
            // Delete
            .addCase(deleteMenuItem.fulfilled, (state, action) => {
                state.items = state.items.filter((item) => item._id !== action.payload);
            });
    },
});

export default menuSlice.reducer;
